<template>
  <div class="upload">
    <Header title="上传图片" :show-back="true" />
    <!-- <div class="upload-image">
      <img v-if="!imageFile" class="default" src="../../assets/img/upload/image_btn.png" />
      <input type="file" @change="uploadFile" class="upload-input" />
      <img v-if="imageFile" :src="imageFile" />
    </div> -->
    <van-uploader
      :deletable="false"
      class="upload-image"
      v-model="fileList"
      image-fit="contain"
    >
      <img v-if="fileList.length===0" class="default" src="../../assets/img/upload/image_btn.png" />
      <p v-if="fileList.length===0" class="text">请点击上传图片</p>
      <view></view>
    </van-uploader>
    <div class="upload-btn">
      <button class="form-item-btn" @click="upload">
        <span>确认上传</span>
        <img src="../../assets/img/upload/right.png" />
      </button>
    </div>
  </div>
</template>
<script>
import Header from "../../components/header";
export default {
  components: {
    Header
  },
  data() {
    return {
      imageFile: "",
      file:null,
      fileList:[]
    };
  },
  methods: {
    goDetail() {
      this.$router.push({ path: "/announcement" });
    },
    upload(){
      if(this.fileList.length===0){
        this.$toast('请选择上传图片')
        return
      }
      let data = new FormData();
      data.append("file_path", "upload/sign/");
      data.append("file_upload", this.fileList[0].file);
      console.log(this.fileList[0].file);
      let config={
        headers:{
          'Content-Type': 'multipart/form-data'
        }
      }
      this.ajax.post('appapi/Uploade/uploadFile',data,config).then((res)=>{
        if(res.data.code === 1){
          this.$toast(res.data.msg)
          setTimeout(()=>{
            this.signIn(res.data.data)
          },1000)

        }
      })

    },
    //图片签到
    signIn(img){
      this.ajax.post('appapi/User/picSign',{'pic_path':img}).then((res)=>{
        if(res.data.code===1){
          this.$toast(res.data.msg)
          this.$router.go(-1)
        }
      })
    }
  }
};
</script>
<style lang="scss">
.upload {
  background: #fff;
  height: 100vh;
  &-image {
    width: 600px;
    height: 418px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 8px 21px 0px rgba(226, 226, 226, 0.8);
    border-radius: 10px;
    margin: 53px auto 92px;
    position: relative;
    @include flex($cross: center, $main: center);
    .default {
      width: 215px;
      height: 188px;
      margin: auto;
    }
    .van-uploader__preview-image{
      width:100%;
      height: 418px;
      max-width:100%;
      max-height:100%;
    }
    .text{
      color:#10914A;
      font-size:28px;
      margin-top:26px;
    }
  }
  &-input {
    position: absolute;
    width: 215px;
    height: 188px;
    background: #eee;
    opacity: 0;
  }
  &-btn {
    padding: 75px;
    position: relative;
    .form-item-btn {
      @include flex($cross: center, $main: center);
      img {
        width: 56px;
        height: 23px;
      }
    }
  }
}
</style>
